import { render, staticRenderFns } from "./MunicipalCredentialCard.vue?vue&type=template&id=28cddd9e&scoped=true&lang=pug"
import script from "./MunicipalCredentialCard.vue?vue&type=script&lang=js"
export * from "./MunicipalCredentialCard.vue?vue&type=script&lang=js"
import style0 from "./MunicipalCredentialCard.vue?vue&type=style&index=0&id=28cddd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cddd9e",
  null
  
)

export default component.exports